import React from 'react';

import Section from '../section/section.component';
import MarkdownToJsx from '../markdown-to-jsx/markdown-to-jsx.component';

import './getting-started.styles.scss';


export default function GettingStarted() {
  const mdPath = [process.env.PUBLIC_URL, 'markdown', 'gettingStarted.md'].join('/');
  const content = <MarkdownToJsx path={mdPath} />

  return (
    <Section className='getting-started-container'>
      {content}
    </Section>
  );
}
